(() => {
  'use strict';
  const dialog = document.querySelector('[data-store-regions]');
  if (!dialog || !dialog.showModal) return;
  const entryParameter = 'choose-store';
  const entryPendingKey = 'sothing-region-entry-pending';
  const entryUrl = new URL(window.location.href);
  let shouldOpenFromMainSite = entryUrl.searchParams.get(entryParameter) === '1';
  if (shouldOpenFromMainSite) {
    try { sessionStorage.setItem(entryPendingKey, '1'); } catch {}
    entryUrl.searchParams.delete(entryParameter);
    history.replaceState(history.state, '', entryUrl.pathname + entryUrl.search + entryUrl.hash);
  } else {
    try { shouldOpenFromMainSite = sessionStorage.getItem(entryPendingKey) === '1'; } catch {}
  }
  const tabs = [...dialog.querySelectorAll('[data-region]')];
  const panels = [...dialog.querySelectorAll('[data-region-panel]')];
  let opener;
  const currentTab = tabs.find(tab => tab.dataset.region === dialog.dataset.currentRegion) || tabs[0];
  const select = tab => {
    tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
    panels.forEach(panel => { panel.hidden = panel.dataset.regionPanel !== tab.dataset.region; });
  };
  const open = trigger => { opener = trigger; select(currentTab); if (!dialog.open) dialog.showModal(); };
  document.querySelectorAll('[data-region-open]').forEach(button => button.addEventListener('click', () => open(button)));
  dialog.querySelector('[data-region-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { opener?.focus(); });
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', event => {
      let next;
      if (['ArrowDown','ArrowRight'].includes(event.key)) next = (index + 1) % tabs.length;
      if (['ArrowUp','ArrowLeft'].includes(event.key)) next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); select(tabs[next]); tabs[next].focus(); }
    });
  });
  dialog.querySelectorAll('[data-region-back]').forEach(button => button.addEventListener('click', () => { select(currentTab); currentTab.focus(); }));
  dialog.querySelectorAll('form').forEach(form => {
    const country = form.querySelector('[name="country_code"]');
    const language = form.querySelector('[name="language_code"]');
    const currency = form.querySelector('[data-region-currency]');
    const synchronize = () => {
      const option = country?.selectedOptions[0];
      if (!option || !language) return;
      let languages;
      try { languages = JSON.parse(option.dataset.languages || '[]'); } catch { languages = []; }
      if (languages.length) {
        const previous = language.value;
        language.replaceChildren(...languages.map(item => {
          const choice = document.createElement('option');
          choice.value = item.code; choice.lang = item.code; choice.textContent = item.name; return choice;
        }));
        const preferred = option.dataset.defaultLanguage || dialog.dataset.currentLanguage;
        language.value = languages.some(item => item.code === preferred) ? preferred : languages.some(item => item.code === previous) ? previous : languages[0].code;
      }
      if (currency) currency.textContent = option.dataset.currency;
    };
    country?.addEventListener('change', synchronize);
    synchronize();
    // Shopify adjusts this locale-aware path to the destination selected in this form.
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search;
    form.addEventListener('submit', event => {
      try { sessionStorage.removeItem(entryPendingKey); } catch {}
      if (country?.value === document.body.dataset.storeCountry && language?.value === document.documentElement.lang) { event.preventDefault(); dialog.close(); }
    });
  });
  select(currentTab);
  if (shouldOpenFromMainSite) { try { sessionStorage.removeItem(entryPendingKey); } catch {} open(); }
})();
